import { createFileRoute } from "@tanstack/react-router";

import { NodesPanel } from "../../../../workspaces/settings/platform/NodesPanel";

export const Route = createFileRoute("/_console/settings/platform/nodes")({
  component: NodesPanel,
});
